const ContactFormService = require('contact/contact-form-service.js');
const PipedriveService = require('contact/pipedrive-service.js');
const Tracking = require('tracking/tracking-controller.js');
const Utils = require('core-helpers/utils.js');

(function (root, doc, undefined) {
    'use strict';

    // Private vars
    const MAX_TEXTAREA_LENGTH = 2000;
    const SPINNER_CLASSES = 'main-spinner-a main-spinner--light-a';
    const WEB_AUTOMATION_TEST_EMAIL = 'web_automation_super_admin@busuu.com';
    const isProduction = Utils.isProduction();
    let contactForm = null;
    let contactFormSuccess = null;
    let contactFormName = null;
    let contactFormEmail = null;
    let contactFormPhone = null;
    let contactFormOrgName = null;
    let contactFormLicences = null;
    let contactFormMessage = null;
    let contactFormSubmit = null;
    let contactFormError = null;
    let contactFormRemaining = null;

    // Returns a translation
    const getTranslation = (key) => {
        return BUSUU_TRANSLATIONS[key] || 'NOT FOUND';
    };

    const enableSpinner = () => {
        Utils.addClass(contactFormSubmit, SPINNER_CLASSES);
    };

    const disableSpinner = () => {
        Utils.removeClass(contactFormSubmit, SPINNER_CLASSES);
    };

    const enableSubmit = () => {
        contactFormSubmit.removeAttribute('disabled', 'disabled');
    };

    const disableSubmit = () => {
        contactFormSubmit.setAttribute('disabled', 'disabled');
    };

    const showFormError = () => {
        Utils.removeClass(contactFormError, 'hide');
    };

    const hideFormError = () => {
        Utils.addClass(contactFormError, 'hide');
    };

    const handleMessageCharCount = () => {

        let remainingLength = MAX_TEXTAREA_LENGTH - contactFormMessage.value.length;

        // Turn text red
        if (remainingLength < 0) {
            Utils.addClass(contactFormRemaining, 'contact-form__remaining--error');
            disableSubmit();
        } else {
            Utils.removeClass(contactFormRemaining, 'contact-form__remaining--error');
            enableSubmit();
        }

        let remainingTrans = getTranslation('YOU_HAVE_X_CHARS_LEFT');
        contactFormRemaining.innerText = remainingTrans.replace('%s', remainingLength);
    };

    const showContactFormSuccess = () => {
        Utils.addClass(contactForm, 'hide');
        Utils.removeClass(contactFormSuccess, 'hide');
    };

    const sendTracking = () => {
        Tracking.send('CONTACT_SENT_SUCCESS', {
            referrer: document.referrer
        });
    };

    // When starting API call, disable send button & enable spinner
    const onSubmitStart = () => {
        disableSubmit();
        enableSpinner();
        hideFormError();
    };

    /**
     * Handles the completion of both API calls:
     * - Send internal email to 'sales@busuu.com'
     * - Create Pipedrive deal with linked person and organisation
     * @param {event} Triggered by SUBMIT of the Org Form - includes all the input values
     */
    const handleFullSubmission = (e) => {
        // Prevent default to stop redirect after form submission
        e.preventDefault();

        // Disable the button and activate spinner
        onSubmitStart();

        // Build up our request parameters
        const requestParams = {
            name: contactFormName.value,
            email: contactFormEmail.value,
            phone: contactFormPhone.value,
            institution_name: contactFormOrgName.value,
            licences: contactFormLicences.value,
            message: contactFormMessage.value
        };

        // On successful API response
        const onSubmitSuccess = () => {
            showContactFormSuccess();
            sendTracking();
        };

        // On error API response
        const onSubmitError = () => {
            showFormError();
        };

        // On API call complete, enable send button, & disable spinner
        const onSubmitComplete = () => {
            enableSubmit();
            disableSpinner();
        };

        // Fake the contact success form if automation or local / testing environments
        if (!isProduction || (requestParams.email === WEB_AUTOMATION_TEST_EMAIL)) {
            return showContactFormSuccess();
        }

        const pipeDrivePromise = PipedriveService.postPipedriveForm(requestParams);
        const emailPromise = () => { ContactFormService.postContactForm('feedbackOrg', requestParams); };

        pipeDrivePromise
            .then(emailPromise)
            .then(onSubmitSuccess)
            .catch(onSubmitError)
            .finally(onSubmitComplete)
            .done();
    };

    const initForm = () => {
        contactForm = Utils.getById('contact-form');

        // No contact form on this page.
        if (!contactForm) {
            return false;
        }

        // Get success page
        contactFormSuccess = Utils.getById('contact-success');

        // Get all inputs by ID
        contactFormName = Utils.getById('contact-form-name');
        contactFormEmail = Utils.getById('contact-form-email');
        contactFormPhone = Utils.getById('contact-form-phone');
        contactFormOrgName = Utils.getById('contact-form-org-name');
        contactFormLicences = Utils.getById('contact-form-licences');
        contactFormMessage = Utils.getById('contact-form-message');
        contactFormSubmit = Utils.getById('contact-form-submit');
        contactFormError = Utils.getById('contact-form-error');
        contactFormRemaining = Utils.getById('contact-form-remaining-chars');

        // Add event listener to form
        contactForm.addEventListener('submit', handleFullSubmission);
        contactFormMessage.addEventListener('keyup', handleMessageCharCount);

        // Add keypress listener to textarea
        handleMessageCharCount();
    };

    // On controller init
    const init = () => {

        // Init contact form
        initForm();
    };

    init();

})(window, document);
